/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, Input, Output, ChangeDetectionStrategy} from '@angular/core';
import {Subject} from 'rxjs';
import {SettlementDetailFooterActionsEnum} from '../models/settlement-detail-footer-actions.enum';
import {SettlementDetailFooterConfigurationModel} from '../services/settlement-detail-configuration/models/settlement-detail-footer-configuration.model';

@Component({
    selector: 'app-settlement-footer',
    templateUrl: './settlement-footer.component.html',
    styleUrls: ['./settlement-footer.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SettlementFooterComponent {

    @Output() action: Subject<SettlementDetailFooterActionsEnum> = new Subject<SettlementDetailFooterActionsEnum>();

    @Input() configuration: SettlementDetailFooterConfigurationModel = <SettlementDetailFooterConfigurationModel>{};

    footerClick(action: SettlementDetailFooterActionsEnum): void {
        this.action.next(action);
    }
}
